var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppIconLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5244_12048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7499 0C18.6617 0 18.5735 0.00881912 18.4854 0.0176382C18.6441 0.0176382 18.794 0.0176382 18.9528 0.0176382C18.8822 0.0176382 18.8205 0.00881912 18.7499 0.00881912V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62012 3.71264C10.4863 1.61369 13.917 0.334916 17.4799 0.0615234C13.8023 0.308459 10.4246 1.63133 7.62012 3.71264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0878906 17.0122C0.0967097 16.8711 0.123167 16.73 0.140805 16.5801C0.123167 16.7212 0.105529 16.8623 0.0878906 17.0122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.370117 15.0629C0.370117 15.0629 0.387755 14.9835 0.387755 14.9482C0.387755 14.9835 0.370117 15.0276 0.370117 15.0629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62305 4.48874C6.85234 4.29472 7.09046 4.10952 7.32858 3.92432C7.09046 4.10952 6.85234 4.29472 6.62305 4.48874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6621 3.92432C92.9002 4.10952 93.1383 4.29472 93.3676 4.48874C93.1383 4.29472 92.9002 4.10952 92.6621 3.92432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2507 3.00575e-05C81.1801 3.00575e-05 81.1184 0.00884918 81.0479 0.00884918C81.2066 0.00884918 81.3565 0.00884918 81.5153 0.00884918C81.4271 0.00884918 81.3389 -0.00878906 81.2507 -0.00878906V3.00575e-05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6035 14.9482C99.6035 14.9482 99.6212 15.0276 99.6212 15.0629C99.6212 15.0276 99.6035 14.9835 99.6035 14.9482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5205 0.0615234C86.0834 0.334916 89.5141 1.61369 92.3803 3.71264C89.5846 1.63133 86.1981 0.317278 82.5205 0.0615234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8594 16.5801C99.877 16.7212 99.8946 16.8623 99.9123 17.0122C99.8946 16.8711 99.877 16.73 99.8594 16.5801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33789 3.92455C7.4349 3.854 7.52309 3.78344 7.6201 3.71289C7.52309 3.78344 7.42608 3.854 7.33789 3.92455Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4795 0.0617038C17.8146 0.0352464 18.1497 0.0176082 18.4849 0.00878906C18.1497 0.00878906 17.8146 0.0352464 17.4795 0.0617038Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.140625 16.5799C0.202359 16.0684 0.272912 15.5569 0.369922 15.063C0.272912 15.5569 0.19354 16.0684 0.140625 16.5799Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.7408C0 18.1587 0.0352765 17.5767 0.0881912 17.0034C0.0352765 17.5767 0 18.1499 0 18.7408Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62278 4.48877C3.54491 7.07277 1.26076 10.6622 0.396484 14.9482C1.26076 10.8033 3.50963 7.15214 6.6316 4.49759L6.62278 4.48877Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5146 0.0175781C81.8498 0.0175781 82.1849 0.0440355 82.52 0.0704928C82.1849 0.0440355 81.8498 0.0263972 81.5146 0.0175781Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 18.7408C100 18.1499 99.965 17.5767 99.9121 17.0034C99.965 17.5767 100 18.1587 100 18.7408Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3799 3.71289C92.4769 3.78344 92.5739 3.854 92.6621 3.92455C92.5651 3.854 92.4769 3.78344 92.3799 3.71289Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6033 14.9482C98.7302 10.6621 96.4549 7.08156 93.3682 4.49756C96.4901 7.15211 98.739 10.8032 99.6033 14.9482Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6299 15.063C99.7269 15.5657 99.8063 16.0684 99.8592 16.5799C99.7974 16.0684 99.7269 15.5569 99.6299 15.063Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5244_12048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5001 32.1085L62.4784 64.239L62.2393 64.4781V81.1955C62.2393 91.5433 70.6306 99.9998 80.8914 99.9998H81.3045C91.5653 99.9998 99.9566 91.5433 99.9566 81.1955V18.8042C99.9566 23.6085 98.1306 28.4346 94.4567 32.1085H94.5001Z",
    fill: "#89A6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 18.8043C99.9999 8.45652 91.6086 0 81.3477 0H80.9347C74.9781 0 69.652 2.84783 66.239 7.26087C63.7607 10.4565 62.2607 14.4565 62.2607 18.8043V64.4783L62.4999 64.2391L94.5216 32.1087C98.1738 28.4348 100.022 23.6304 100.022 18.8043H99.9999Z",
    fill: "#472A3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50047 32.1085L37.5222 64.239L37.7613 64.4781V81.1955C37.7613 91.5433 29.37 99.9998 19.1092 99.9998H18.6961C8.43525 99.9998 0.0439453 91.5433 0.0439453 81.1955V18.8042C0.0439453 23.6085 1.87003 28.4346 5.54395 32.1085H5.50047Z",
    fill: "#89A6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9999 76.7178L37.739 64.4786V18.8047C37.739 14.4569 36.239 10.4569 33.7607 7.26123C38.152 12.1091 43.9781 14.5438 49.9781 14.5438C55.9781 14.5438 61.8042 12.1091 66.1955 7.26123C63.7173 10.4569 62.2173 14.4786 62.2173 18.8264V64.4786L49.9564 76.7178H49.9999Z",
    fill: "#F38183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.8043C0 8.45652 8.3913 0 18.6522 0H19.0652C25.0217 0 30.3261 2.84783 33.7391 7.26087C36.2174 10.4565 37.7174 14.4565 37.7174 18.8043V64.4783L37.4783 64.2391L5.5 32.1087C1.82609 28.4348 0 23.6304 0 18.8043Z",
    fill: "#472A3C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5244_12048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5244_12048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconLarge);
export default __webpack_public_path__ + "static/media/AppIconLarge.2923bfca1fb7bbe55363cafa3c3f47eb.svg";
export { ForwardRef as ReactComponent };